import React, { Component } from 'react';
import Modal from '../Modal';
import Header from '../../components/main.header.component';
class Beer extends Component {
  constructor(){
    super();
    this.state = {
      isOpen: false,
      url: ''
    };
  }
  componentDidMount() {
    window.scrollTo(0,0);
  }
  openModal = (evt) => {
    let url = evt.target.src;
    if(url){ // clicking the actual image opens the Modal, and not just Div padding
      this.setState({
        isOpen: true,
        url: url
      });
    }
  }

  closeModal = (evt) => {
    this.setState({
      isOpen: false,
      url: ''
    });
  };

  render() {
    return (
      <div className="beer">
        <Header
          props={this.props}
        />
        <div className="beer-headline">
            <i>Peach For The Stars</i> <br />
          <div className="beer-subline">
            Gluten-Free half mash IPA, made with Citra & Mosaic hops.<br />
            Naturally flavored with peach fruit extract.
            <br />
          </div>
        </div>
        <div className="beer-text">
         <p>Let's be real: I only make beers for the pun titles. <br />
         I'll have a beer name pun, or even a loose idea and run with it.</p>
         Originally I wanted to call it: <i><a href="https://getyarn.io/yarn-clip/03334bda-a09a-47ec-8bed-5fbff2b546db" target="_blank" rel="noopener noreferrer">PAPA DON’T PEACH (Don't you stop loving me daddy) </a></i> <br /> but... I think I landed on the better title.
         <p>Collaborating with an amazing designer, Druscilla (<a href="https://www.adventurefun.club/" target="_blank" rel="noopener noreferrer">@adventurefunclub</a>),
          she was able to take my idea of a bad boi peach, holding up guns (à la the classic western / cowboy <i>"Reach for the Stars, dirtbag!"</i> ) and create the freshest label. <br/>
         </p>
        </div>
        <div className="beer-responsive">
          <div className="beer-image" onClick={this.openModal}>
            <img src="/images/peach-beer/peach-bottle-real.jpg" alt=""/>
          </div>
          <div className="beer-image" onClick={this.openModal}>
            <img src="/images/peach-beer/peach-bottles.jpeg" alt=""/>
          </div>
          <div className="beer-image" onClick={this.openModal}>
            <img src="/images/peach-beer/peach-real.jpg" alt=""/>
          </div>
        </div>

          <div className="beer-text-small">
            Ingredients
            <div id="ingredients-list">
              <ul>
                <li> 3 lbs Alexander's Pale Liquid Malt Extract</li>
                <li> 3 lbs Briess Munich Liquid Malt Extract</li>
                <li> 1 lb CaraWheat 45L </li>
                <li> 1 lb Honey Malt </li>
                <li> 4 oz Peach Flavoring Extract</li>
              </ul>
              <ul>
                <li> 2oz Mosaic hops</li>
                <li> 2oz Citra hops</li>
                <li> US-05 Yeast ( I used dry ) </li>
                <li> Whirlfloc Tablet</li>
              </ul>
            </div>
            <div id="instructions">
            Mash your grains in 5 quarts of water at 165 F. <br />
            Hold temp for 30 minutes at 150 F. <br /><br />
            Heat up your Sparge water, 3 gallons of water at 170 F.<br />
            Dunk the grain bag into the sparge water stir grains for 10 minutes <br />
            Add your Liquid Malt Extract at this point and stir until disollved <br /><br />
            Boil the wort for 30 minutes and add your hops:
            <ul>
              <li>At 10 minutes add 1/2 oz Citra and 1/2 Mosaic.</li>
              <li>At 5 minutes add 1/2 oz Citra, 1/2 Mosaic and your Whirlfloc Tablet.</li>
              <li>At 0 minutes, turn off heat, chill down to 180 F and add 1 oz Citra, 1 oz Mosaic and let sit 15 minutes.</li>
            </ul>
            <br />
            Cool your wort to between 60-70 F. <br />
            Top with water to total 5 and 1/4 gallons in your fermenter.
            <br />
            Pitch the yeast and ferment for 14 days at 60-70 F.<br /><br />
            During bottling, add Peach Extract ( I used all 4 oz ).
            <br /> <br />
            <h5>Target Original Gravity: 1.045 <br /> <br />
            Final Gravity: 1.010 <br /> <br /></h5>
            </div>
          </div>

        <div className="beer-headline" style={{color:'#f7d76c'}}>
            <i>Lazy Rabbit </i> <br />
          <div className="beer-subline">
            Single Hop Pale Ale infused with Lemongrass and Orange Zest tea
            <br />
          </div>
          <div id="instructions">
           <h3> coming soon! </h3>
          </div>
        </div>

          <Modal
            show={this.state.isOpen}
            onClose={this.closeModal}
            className="Modal-Backdrop" >
              <img
                className="moto-image"
                src={this.state.url}
                alt="mototrip"
              />

          </Modal>
      </div>
    );
  }
}

export default Beer;

